import { render, staticRenderFns } from "./research-list.vue?vue&type=template&id=7ee5a933&scoped=true&"
import script from "./research-list.vue?vue&type=script&lang=js&"
export * from "./research-list.vue?vue&type=script&lang=js&"
import style0 from "./research-list.vue?vue&type=style&index=0&id=7ee5a933&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee5a933",
  null
  
)

export default component.exports